import { render, staticRenderFns } from "./DialogLayoutFull.vue?vue&type=template&id=4a39dd44&scoped=true"
import script from "./DialogLayoutFull.ts?vue&type=script&lang=ts&external"
export * from "./DialogLayoutFull.ts?vue&type=script&lang=ts&external"
import style0 from "./DialogLayoutFull.scss?vue&type=style&index=0&id=4a39dd44&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a39dd44",
  null
  
)

export default component.exports